export default {
  500: {
    title: "500 - Internal Server Error",
    message: "予期せぬエラーが発生しました。I18n",
  },
  404: {
    title: "404 - Page Not Found",
    message: `ページがみつかりませんでした。
    申し訳ございませんが、お探しのページが見つかりませんでした。
    削除されたか、URLが間違っている可能性があります。`,
  },
};
